export function animate(el, cssClass) {
    return new Promise((resolve) => {
        el.classList.add(cssClass);
        function onAnimationEnd(e) {
            const el = e.target;
            el.removeEventListener('animationend', onAnimationEnd);
            el.classList.remove(cssClass);
            resolve(el);
        }
        el.addEventListener('animationend', onAnimationEnd);
    });
}
//# sourceMappingURL=animate.js.map